/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Shell_Pick_WaitingInputs */

const en_auth_shell_pick_waiting = /** @type {(inputs: Auth_Shell_Pick_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is waiting for you after sign-in.`)
};

const pl_auth_shell_pick_waiting = /** @type {(inputs: Auth_Shell_Pick_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czeka na Ciebie po zalogowaniu.`)
};

/**
* | output |
* | --- |
* | "It is waiting for you after sign-in." |
*
* @param {Auth_Shell_Pick_WaitingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_shell_pick_waiting = /** @type {((inputs?: Auth_Shell_Pick_WaitingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Shell_Pick_WaitingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_shell_pick_waiting(inputs)
	return en_auth_shell_pick_waiting(inputs)
});